import { render, staticRenderFns } from "./TenRatingView.vue?vue&type=template&id=5723f164&scoped=true&"
import script from "./TenRatingView.vue?vue&type=script&lang=js&"
export * from "./TenRatingView.vue?vue&type=script&lang=js&"
import style0 from "./TenRatingView.vue?vue&type=style&index=0&id=5723f164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723f164",
  null
  
)

export default component.exports